import { Image } from "@tiptap/extension-image";
import { ReactNodeViewRenderer } from "@tiptap/react";
import ImageWithDownload from "./ImageWithDownload";

export const CustomImage = Image.extend({
  addAttributes() {
    return {
      // Keep the base src/alt/title attributes
      ...this.parent?.(),
      // Brief/article id — needed to rebuild the S3 path + refetch brand
      // guidelines when regenerating a single image.
      articleId: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-article-id"),
        renderHTML: (attributes) =>
          attributes.articleId
            ? { "data-article-id": attributes.articleId }
            : {},
      },
      // Full generation "opportunity" (image_prompt, goal_statement, alt_text,
      // image_type, text_in_image, aspect_ratio, placement_context, is_cover).
      // Drives the per-image "regenerate with a comment" control. JSON-encoded
      // into a data attribute. NOTE: the editor persists content as markdown
      // (Turndown), which drops data-* attributes — so the article editor keeps
      // a separate src -> opportunity map and restores it onto image nodes on
      // load AND after every content replacement (see
      // src/utils/imageOpportunityRestore.ts).
      imageOpportunity: {
        default: null,
        parseHTML: (element) => {
          const raw = element.getAttribute("data-image-opportunity");
          if (!raw) return null;
          try {
            return JSON.parse(raw);
          } catch {
            return null;
          }
        },
        renderHTML: (attributes) =>
          attributes.imageOpportunity
            ? {
                "data-image-opportunity": JSON.stringify(
                  attributes.imageOpportunity
                ),
              }
            : {},
      },
    };
  },
  addNodeView() {
    return ReactNodeViewRenderer(ImageWithDownload);
  },
});
